import axios from "axios";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { API_URL } from "../../const/api";
import { mobile_normal } from "../../const/fonts";
import InputPhoneNumber from "../InputPhoneNumber";
import ErrorContainer from "./ErrorContainer";
import CheckIcon from "@mui/icons-material/Check";
import { useSelector } from "react-redux";
import { selectDetectedCountry } from "../../features/user/userSlice";
import { countries } from "../../const/countries";

const Container = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  margin: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  label {
    font-weight: bold;
  }

  @media screen and (max-width: 2000px) {
    width: 100%;
    input,
    label {
      font-size: 0.8rem;
    }
    div {
      margin-top: 0.2rem;
    }

    img {
      width: 20px;
    }
    h3 {
      font-size: 0.8rem;
    }
  }

  @media screen and (max-width: 1600px) {
    margin: 0.25rem 1rem;
  }
  @media screen and (max-width: 768px) {
    margin: 1rem auto;

    label,
    input,
    h3 {
      font-size: ${mobile_normal};
    }
    input {
      color: white;
      text-align: justify;
      font-weight: bold;
      font-size: 14px;
    }
    div {
      margin-top: 0.25rem;
    }
    div button {
      padding: 0.325rem;
    }
    img {
      width: 22px;
    }
  }
`;

const Check = styled(CheckIcon)`
  color: #28a745;
  position: absolute;
  right: 0.5rem;
  top: 1.78rem;
`;

const PhoneBox = ({
  value,
  handleCountry,
  handleChange,
  handleBlur,
  error,
  mycountry,
  area,
}) => {
  const [focused, setFocused] = useState(false);
  const [serverError, setServerError] = useState("");
  const [countryCode, setCountryCode] = useState("");

  const country = useSelector(selectDetectedCountry);

  const [countryInfo, setCountryInfo] = useState(null);

  useEffect(() => {
    const pais = countries.find((x) => x.flag === country);
    setCountryInfo(pais);
  }, []);

  const selectCountryCode = (code) => setCountryCode(code);

  const handleFocus = async (e) => {
    if (handleBlur) {
      handleBlur(e);
    }
    setFocused(true);
    let tlf = `${countryCode} ${area}${value}`
    
    const res = await axios.post(API_URL + "validarFormulario", {
      telefono: tlf,
    });

    if (country === "VE" || country === "BR" || mycountry==='VE' || mycountry === 'BR') {
      if (area === "") {
        setServerError("Por favor ingrese su número de área.");
      } else {
        if (res.data.response.error === 1) {
          setServerError(res.data.response.tipo);
        } else {
          setServerError('')
        }
      }
    } else if (res.data.response.error === 1) {
      setServerError(res.data.response.tipo);
    } else {
      setServerError(null);
    }
  };

  const handleNumberChange = (e) => {
    const { value } = e.target;
    const regex = /^[0-9]*$/; // Solo permite números
    if (regex.test(value)) {
      handleChange(e); // llama a handleChange si el valor es válido
    }
  };

  return (
    <Container>
      <InputPhoneNumber
        action="validate"
        handleChange={handleNumberChange}
        handleBlur={handleFocus}
        className={
          (error || serverError) && focused
            ? "error"
            : (!error || !serverError) && focused
            ? "correct"
            : null
        }
        handleCountry={handleCountry}
        selectCountryCode={selectCountryCode}
        value={value}
        pattern="[0-9]*" // Solo permite números en dispositivos móviles
        inputMode="numeric" // Sugerir teclado numérico en dispositivos móviles
        type="tel" // Tipo de entrada telefónica para dispositivos móviles
        mycountry={mycountry}
        countryDetected={country}
        areaCode={area}
      />
      {focused && (error || serverError) && (
        <ErrorContainer
          focused={focused.toString()}
          error={error || serverError}
        />
      )}
      {!(error || serverError) && focused && <Check />}
    </Container>
  );
};

export default PhoneBox;
